export default __webpack_public_path__ + "static/media/ic_democratic_republic_of_congo.09ed48e2.svg";